var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "message-list" },
    [
      _vm._l(_vm.chats, function (chat) {
        return _c(
          "div",
          {
            key: chat.id,
            class: [
              "chat-item",
              {
                unread: chat.unreadCount > 0,
                active: _vm.activeChatId === chat.id,
              },
            ],
            on: {
              click: function ($event) {
                return _vm.openChat(chat)
              },
            },
          },
          [
            _c("img", {
              staticClass: "chat-avatar",
              attrs: { src: chat.userImageUrl, alt: "" },
            }),
            _c("div", { staticClass: "chat-info" }, [
              _c("div", { staticClass: "chat-header" }, [
                _c("div", { staticClass: "chat-name" }, [
                  _vm._v(_vm._s(chat.userName)),
                ]),
                _c("div", { staticClass: "chat-time" }, [
                  _vm._v(_vm._s(_vm.getRelativeTime(chat.lastSendTime))),
                ]),
              ]),
              _c("div", { staticClass: "chat-preview" }, [
                _vm._v(_vm._s(chat.newContent)),
              ]),
            ]),
            chat.unReadNumber > 0
              ? _c("div", { staticClass: "chat-unread" }, [
                  _vm._v(_vm._s(chat.unReadNumber)),
                ])
              : _vm._e(),
          ]
        )
      }),
      _vm.chats.length === 0
        ? _c("div", { staticClass: "empty-state" }, [
            _c("i", { staticClass: "fas fa-comments" }),
            _c("h3", [_vm._v("暂无聊天")]),
            _c("p", [_vm._v("您还没有与任何用户的聊天记录")]),
          ])
        : _vm._e(),
      _vm.chats.length > 0
        ? _c("Pagination", {
            attrs: {
              currentPage: _vm.page,
              pageSizes: [10, 20, 30, 40],
              parentPageSize: _vm.size,
              totalNumber: _vm.totalNumber,
            },
            on: { loadTable: _vm.loadTable },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }